// extracted by mini-css-extract-plugin
module.exports = {"app":"_App_app__gM_4C"};